import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminPanelOptica from "./Components/AdminComp/adminpanel-optica";
import AdminPanelCommunity from "./Components/AdminComp/adminpanel-community";
import AdminPanelInstitute from "./Components/AdminComp/adminpanel-institute";
import AdminPanelAsianPolytechnic from "./Components/AdminComp/adminpanel-asianpolytechnic";
import Login from "./Components/LoginComp/login";
import PrivateRoute from "./Utils/PrivateRoute";
import { auth, db } from "./Components/LoginComp/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { ToastContainer } from "react-toastify";
import AdminpanelEyecare2026 from "./Components/AdminComp/adminpanel-eyecare2026";





const App = () => {
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          setUserRole(userDoc.data().role);
        }
      } else {
        setUserRole(null);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <Router>
           <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />
  
      
            <Route
              path="/adminpanel-optica"
              element={
                <PrivateRoute role="admin-optica" userRole={userRole}>
                  <AdminPanelOptica />
                </PrivateRoute>
              }
            />




            <Route
              path="/adminpanel-community"
              element={
                <PrivateRoute role="admin-community" userRole={userRole}>
                  <AdminPanelCommunity />
                </PrivateRoute>
              }
            />

            <Route
              path="/adminpanel-institute"
              element={
                <PrivateRoute role="admin-institute" userRole={userRole}>
                  <AdminPanelInstitute />
                </PrivateRoute>
              }
            />  

            <Route
              path="/adminpanel-asianpolytechnic"
              element={
                <PrivateRoute role="admin-asianpolytechnic" userRole={userRole}>
                  <AdminPanelAsianPolytechnic />
                </PrivateRoute>
              }
            />
  
            <Route
              path="/adminpanel-eyecare2026"
              element={
                <PrivateRoute role="admin-eyecare2026" userRole={userRole}>
                  <AdminpanelEyecare2026 />
                </PrivateRoute>
              }
            />


      </Routes>
   
    </Router>

    
  );
};

export default App;